<template>
  <v-card
    class="fill-height d-flex flex-column"
    :href="pdf"
    elevation="5"
  >
    <v-img
      :src="pdfThumb"
      :aspect-ratio="3/4"
      contain
    />
    <v-divider />
    <v-card-title><v-chip v-if="chip">{{ chip }}</v-chip> {{ label }}</v-card-title>
    <v-card-actions>
      <v-btn :color="mainColor" class="lighten-2" block :href="pdf">öffnen</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

  import { assets_url } from '@/assets.js'

  export default {
    name: 'AmtstafelCard',
    props: ["label", "pdf", "mainColor", "chip"],
    components: {
    },
    mounted(){
    },
    computed: {
      pdfThumb(){
        const width = 700
        const height = Math.floor(width/3*4)
        const url = assets_url(this.pdf, `fixed=${width}x${height}`, "/1")
        return url
      }
    },
    data: () => ({
    }),
  }
</script>
